import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { Button, Icon, Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const UploadedModal = ({ isOpen, onClose }: Props) => {
  const { passportNumber } = useAppSelector((state) => state) as IGlobalState;
  const isCruise = passportNumber
    ? localStorage.getItem(`${passportNumber}-transfer`) === 'true'
    : false;

  return (
    <Modal
      isOpen={isOpen}
      hasBackdrop
      wrapperStyle={{ width: '100%', maxWidth: '335px' }}
    >
      <Modal.Header>
        <TitleWrapper>
          <Icon.CheckFilled fillColor='#246CF6' />
          Upload Complete
        </TitleWrapper>
      </Modal.Header>
      <ModalBody>
        <Contents>
          {isCruise
            ? 'Payment will be processed after verification. Payment will be completed within 1~2months after upload.'
            : 'Payment will be processed after verification. Payment will be completed within 21 days after upload.'}
        </Contents>
        <Warning>*You may be asked to re-upload if necessary.</Warning>
      </ModalBody>
      <Modal.Footer>
        <Button type='button' size='sm' onClick={onClose}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default UploadedModal;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: 100%;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  max-width: 320px;
`;

const Contents = styled.p`
  color: var(--KTP-Grayscale-Gray_05, #777);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
  word-break: keep-all;
`;

const Warning = styled.small`
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  font-size: 13px;
  font-weight: 400;
  line-height: 150%; /* 19.5px */
  word-break: keep-all;
`;
